export const INITIAL_FEN =
  "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1";
export const INITIAL_SECONDS_TO_START = 15;
export const INITIAL_TIME_IN_SECONDS = 180;
export const MAX_PLAYERS_IN_TOURNAMENT = 16;
